import FallbackLoading from '@/components/FallbackLoading'
import { getMenuItems } from '@/common/helpers/Manu'
import { Suspense } from 'react'
import AppMenu from './components/AppMenu'
import HoverMenuToggle from './components/HoverMenuToggle'
import LogoBox from '@/components/LogoBox'
import { ScrollableContainer } from '@/components/wrappers/ScrollableContainer'

const VerticalNavigationBarPage = () => {
  const menuItems = getMenuItems()
  return (
    <div className="main-nav">
      <LogoBox />
      <HoverMenuToggle />
      <ScrollableContainer className="scrollbar">
        <Suspense fallback={<FallbackLoading />}>
          <AppMenu menuItems={menuItems} />
        </Suspense>
      </ScrollableContainer>
    </div>
  )
}

export default VerticalNavigationBarPage
